module.exports = __webpack_public_path__ + "1791188489487/fonts/line-awesome.8b12905.woff";